/* Polyfills for IE */
import "core-js/features/object";
import "core-js/features/array";
import "core-js/features/promise";
import "core-js/features/number";
import "core-js/features/url-search-params";

import "@formatjs/intl-pluralrules/polyfill";
import "@formatjs/intl-pluralrules/dist/locale-data/en";
import "@formatjs/intl-pluralrules/dist/locale-data/de";
import "@formatjs/intl-pluralrules/dist/locale-data/es";
import "@formatjs/intl-pluralrules/dist/locale-data/fr";
import "@formatjs/intl-pluralrules/dist/locale-data/ja";
import "@formatjs/intl-pluralrules/dist/locale-data/zh";
